import { useQuery } from '@tanstack/react-query'
import { checkDuplicateLocationOverrideRule } from '../../../api/plan-location-override-rules-api'
import type { CheckDuplicateLocationOverrideRuleQueryDto } from '../../../api/dto/plan-location-override-rules.dto'

export const LOCATION_OVERRIDE_CHECK_DUPLICATE_QUERY_KEY =
  'locationOverrideCheckDuplicate'

export function useCheckDuplicateLocationOverrideRule(
  query: Partial<CheckDuplicateLocationOverrideRuleQueryDto>,
  enabled: boolean
) {
  return useQuery({
    queryKey: [LOCATION_OVERRIDE_CHECK_DUPLICATE_QUERY_KEY, query],
    queryFn: () =>
      checkDuplicateLocationOverrideRule(
        query as CheckDuplicateLocationOverrideRuleQueryDto
      ),
    enabled,
    staleTime: 5_000,
  })
}
